import request from '@/utils/request'

// 获取报价列表
export function getQuoteList(caseId){
    return request({
        url:'/vehicle/quote/list/'+caseId,
        method:'get',
    })
}
// 获取报价详情
export function getQuote(caseId){
    return request({
        url:'/vehicle/quote/detail/'+ caseId,
        method:'get',
    })
}
//增加报价
export function addQuote(para){
    return request({
        url:'/vehicle/quote/add',
        method:'post',
        data:para,
    })
}

